import { isAuthenticated } from "../../../commons/Auth/auth";
import { hasPermission } from "../../../commons/Permissions/PermissionsHook";

/**
 * Whether the signed-in user may see Fördermittel cases in the service-provider panel: the
 * provider, or an employee whose role may read them. The server checks again; this only decides
 * whether to show the entry points (e.g. the tab on the project page).
 */
export const canUseFunding = () => {
  const user = isAuthenticated();
  if (![1, 2].includes(Number(user?.role))) return false;
  return hasPermission(user?.roleId?.permissions, "Funding", "Read");
};
